// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.recount-view .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {\n  padding: 0px 8px !important;\n}\n.mx-auto-full {\n  margin: auto;\n}\n.complete_count_btn {\n  bottom: 4rem!important;\n}\n", ""]);
// Exports
module.exports = exports;
